module.exports = __webpack_public_path__ + "static/fiPines.eaf35610.jpg";